import React from 'react'
import { Link } from 'react-router-dom'
import Team from '../../api/Team'


const TeamSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="team-section section-padding">
            <div className="container content-area">
                <div className="first-row clearfix">
                    <div className="row">
                    <div className="col col-lg-5 col-12">
                        <div className="section-title">
                            <span>#Team</span>
                            <h2>Our Team</h2>
                        </div>
                        <div className="team-details">
                            <p>The Love of Hearts Foundation team is a dedicated group of volunteers and professionals committed to making a meaningful impact in the community.
                                Each member brings unique skills and experiences, from program management and fundraising to community outreach and volunteer coordination.
                                Together, they work tirelessly to support initiatives that uplift and empower individuals, fostering a culture of compassion, collaboration,
                                and positive change.</p>
                            <Link onClick={ClickHandler} to="/" className="theme-btn-s4">Become A Volunteer</Link>
                        </div>
                    </div>
                    <div className="row col col-lg-7 col-12">
                        {Team.map((team, aitem) => (
                            <div className="grid" key={aitem} style={{ display: 'flex', alignItems: 'flex-start', padding: '20px', marginBottom: '60px' , marginRight: '30px'}}>
                                <div
                                    style={{
                                        width: '140%',
                                        height: '140%',
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                        borderRadius: '8px', // optional, makes corners rounded
                                    }}
                                >
                                    <img
                                        src={team.AtImg}
                                        alt={team.name}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover', // ensures image fills container without distortion
                                        }}
                                    />
                                </div>

                                <div className="member-info" style={{ marginLeft: '5px', marginRight: '5px', flex: 1 }}>
                                    <h4>
                                        <Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>
                                            {team.name}
                                        </Link>
                                    </h4>
                                    <p>{team.title}</p>
                                    <ul style={{ display: 'flex', gap: '10px', padding: 0, listStyle: 'none' }}>
                                        <li>
                                            <a
                                                href="https://www.instagram.com/loveofheartsfoundation/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="ti-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/loveofheartsfoundation"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="ti-facebook"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                </div>
            </div>
        </section>
    )
}

export default TeamSection;
